import api from "@/aygulyazilim/libs/axios"
import { router } from "@/plugins/1.router"
import { defineStore } from "pinia"
import { useHelpersStore } from "./useHelpers"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isLoggedIn: localStorage.getItem(import.meta.env.VITE_APP_TITLE + "-token")
      ? true
      : false,
    user: {
      uuid: "",
      name: localStorage.getItem(import.meta.env.VITE_APP_TITLE + "-userName"),
      email: localStorage.getItem(
        import.meta.env.VITE_APP_TITLE + "-userEmail",
      ),
      telefon: "",
      personel: "",
      programci: false,
      admin: false,
      yetkiler: [],
      force_password_change: false,
    },
    userRaw: {
      uuid: "",
      name: localStorage.getItem(import.meta.env.VITE_APP_TITLE + "-userName"),
      email: localStorage.getItem(
        import.meta.env.VITE_APP_TITLE + "-userEmail",
      ),
      telefon: "",
      personel: "",
      programci: false,
      admin: false,
      yetkiler: [],
      force_password_change: false,
    },
  }),
  actions: {
    async logout() {
      const response = (await api.get("auth/logout")).data

      localStorage.removeItem(import.meta.env.VITE_APP_TITLE + "-token")
      this.user = JSON.parse(JSON.stringify(this.userRaw))
      router.push({ name: "login" })
    },

    async ftechUser() {
      const res = await api.get("users/profile")

      if (res != undefined) this.user = res.data

      // await new Promise((resolve) => setTimeout(resolve, 2000));
      this.isLoggedIn = true
    },

    async bootstrap() {
      try {
        const res = await api.get("users/bootstrap")
        if (res && res.data) {
          if (res.data.user) {
            this.user = res.data.user
            this.isLoggedIn = true
          }

          const helpersStore = useHelpersStore()
          if (res.data.licenses) {
            helpersStore.licenses = res.data.licenses.aktif || []
            helpersStore.allModules = res.data.licenses.tum || []
          }
          if (res.data.shortcuts) {
            helpersStore.shortcuts = res.data.shortcuts || []
          }
          if (res.data.menus) {
            helpersStore.setMenus(res.data.menus)
          }

          return res.data
        }
      } catch (error) {
        console.error("Bootstrap error, fallback to ftechUser:", error)
        await this.ftechUser()
      }
    },
  },
})
